import React from 'react';
import PropTypes from 'prop-types';
import '../styles/SoldOut.css';

const SoldOutCard = ({ 
    soldOutImg,
    soldOutTitle,
    soldOutContent,
  }) => {


    return (

    <div className="container-sold-out">

        <h1>{soldOutTitle}</h1>
        
        <div className="sold-img">
          <img src={soldOutImg} alt="Compound sold out"/>
        </div>

        <p>{soldOutContent}</p>

   
    </div>
    );
  };
  
  SoldOutCard.propTypes = {
    soldOutImg: PropTypes.string.isRequired,
    soldOutTitle: PropTypes.string.isRequired,
    soldOutContent: PropTypes.string.isRequired,
  };

export default SoldOutCard;